import gql from 'graphql-tag';

export const getMeterReadingValueForExport = gql(/* GraphQL */ `
  query getMeterReadingValueForExport(
    $meterReadingId: UUID!
    $channelId: String!
    $includeArchived: Boolean
  ) {
    getMeterReadingValueForExport(
      meterReadingId: $meterReadingId
      channelId: $channelId
      includeArchived: $includeArchived
    ) {
      meterReadingValues {
        id
        meterReadingId
        createdBy{
          name
          id
        }
        createdAt
        sourceType
        value
        isArchived
        stepExecutionId
        notes
        taskId
        taskUserFriendlyId
      }
    }
  }
`);
